<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/alt-text -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="flex gap-2 pb-4">
  <div [routerLink]="['/experts']" class="w-fit">
    <span nz-icon nzType="left" nzTheme="outline"></span>
  </div>
  <h1>Update Experts</h1>
</div>
<div class="flex flex-col gap-6 rounded-lg bg-white p-4 w-full">
  <nz-spin [nzSpinning]="pageLoading">
    <div nz-row class="pt-4" nzJustify="end">
      <div nz-col>
        <button [disabled]="viewForm" (click)="showModalEditEmail()" nz-button nzType="primary" class="mr-2">
          Edit Experts Email
        </button>
        <button [disabled]="!viewForm" (click)="enableEdit()" nz-button nzType="primary" class="mr-2">
          Edit Experts
        </button>
        <app-mark-unavailable-slot [therapistId]="this.therapistId"
          [therapistName]="firstName + (lastName ? ' ' + lastName : '')"></app-mark-unavailable-slot>
      </div>
    </div>
    <div class="grid grid-cols-4 gap-4">
      <div class="w-full">
        <label class="form-label required">Mark As Test</label>
        <nz-switch [(ngModel)]="isTesting" [nzDisabled]="viewForm"></nz-switch>
      </div>
      <div class="w-full">
        <label class="form-label required">External</label>
        <nz-switch [(ngModel)]="isExternal" [nzDisabled]="viewForm"></nz-switch>
      </div>
      <div class="w-full">
        <label class="form-label required">In-house retainer</label>
        <nz-switch [(ngModel)]="isInHouseRetainer" [nzDisabled]="viewForm"></nz-switch>
      </div>
    </div>
    <nz-divider nzText="Expert Info"></nz-divider>
    <div class="grid grid-cols-4 gap-4">
      <div class="flex flex-col w-full">
        <label class="form-label">Therapist ID :</label>
        <div class="flex items-center gap-2">
          <input [(ngModel)]="therapistIdDisplay" [disabled]="true" nz-input type="text" placeholder="Therapist ID"
            class="w-full" />
          <button *ngIf="therapistIdDisplay" (click)="copyTherapistId()" nz-button nzType="default" nzSize="small"
            nzShape="circle" nz-tooltip nzTooltipTitle="Copy Therapist ID">
            <span nz-icon nzType="copy" nzTheme="outline"></span>
          </button>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-4 gap-4">
      <div class="flex flex-col w-full">
        <label class="form-label">Select Title :</label>
        <nz-select [(ngModel)]="title" [nzDisabled]="viewForm" nzPlaceHolder="Select Title">
          <nz-option nzValue="Mr" nzLabel="Mr"></nz-option>
          <nz-option nzValue="Ms" nzLabel="Ms"></nz-option>
          <nz-option nzValue="Mrs" nzLabel="Mrs"></nz-option>
          <nz-option nzValue="Dr" nzLabel="Dr"></nz-option>
        </nz-select>
      </div>
    </div>
    <div class="grid grid-cols-4 gap-4">
      <div class="flex flex-col w-full">
        <label class="form-label">First Name :</label>
        <input [(ngModel)]="firstName" [disabled]="viewForm" nz-input type="text" placeholder="Enter First Name"
          class="w-full" />
      </div>
      <div class="flex flex-col w-full">
        <label class="form-label">Last Name :</label>
        <input [(ngModel)]="lastName" [disabled]="viewForm" nz-input type="text" placeholder="Enter Last Name"
          class="w-full" />
      </div>
      <div class="flex flex-col w-full">
        <label class="form-label">Email :</label>
        <input [(ngModel)]="email" [disabled]="true" nz-input type="text" placeholder="Enter Email" class="w-full" />
      </div>
      <div class="flex flex-col w-full">
        <label class="form-label">Phone No :</label>
        <input [(ngModel)]="phoneNo" [disabled]="viewForm" nz-input type="text" placeholder="Enter Phone Number"
          class="w-full" />
      </div>
    </div>
    <div class="grid grid-cols-2 gap-2">
      <div class="flex flex-col gap-1">
        <label class="form-label">Profile Pic</label>
        <img *ngIf="profilePic" [src]="profilePic" class="w-24" alt="ProfilePic" />
        <input [disabled]="viewForm" (change)="uploadTherapistImage($event)" nz-input accept=".jpg,.jpeg,.png"
          type="file" required />
      </div>
      <div class="flex flex-col gap-1">
        <label class="form-label">Video Bio</label>
        <video *ngIf="videoSrc" [src]="videoSrc" controls>
          Your browser does not support the video tag.
        </video>
        <input [disabled]="viewForm" (change)="uploadVideoImage($event)" nz-input accept=".mp4" type="file" required />
      </div>
    </div>
    <div class="grid grid-cols-3 gap-3">
      <div class="w-full">
        <label class="form-label">Archive</label>
        <nz-switch [(ngModel)]="archived" [nzDisabled]="viewForm"></nz-switch>
      </div>
    </div>
    <nz-divider nzText="Therapy info"></nz-divider>
    <div class="grid grid-cols-4 gap-3">
      <div class="w-full">
        <label class="form-label required">Expert consultation</label>
        <nz-switch [(ngModel)]="isTherapist" [nzDisabled]="viewForm"></nz-switch>
      </div>
      <div class="w-full">
        <label class="form-label required">Is Visible</label>
        <nz-switch (ngModelChange)="isVisibleTherapistChangeFn($event)" [(ngModel)]="isVisibleTherapist"
          [nzDisabled]="viewForm"></nz-switch>
      </div>
      <div class="w-full">
        <label class="form-label required">Session Booking Allowed</label>
        <nz-switch [nzDisabled]="
            viewForm || (sessionBookingAllowed && isVisibleTherapist)
          " [(ngModel)]="sessionBookingAllowed"></nz-switch>
      </div>
      <div class="w-full">
        <label class="form-label required">Allow Expert to Book Sessions for Users</label>
        <nz-switch [nzDisabled]="viewForm" [(ngModel)]="canBookSessionForUser"></nz-switch>
      </div>
      <div class="w-full">
        <label class="form-label">Allow Expert to Edit Default Availability</label>
        <nz-switch [nzDisabled]="viewForm" [(ngModel)]="allowEditDefaultAvailability"></nz-switch>
      </div>
      <div class="w-full">
        <label class="form-label">Goals Expert</label>
        <nz-switch [nzDisabled]="viewForm" [(ngModel)]="isGoalsExpert"></nz-switch>
      </div>
      <div class="w-full mb-2">
        <label class="form-label">Minimum Notice Period
          <span nz-tooltip
            nzTooltipTitle="This field represents the minimum number of hours in advance that a booking must be made (ranging from 0 to 72 hours). A value of 0 allows immediate booking with a 30-minute buffer, while higher values require more advance notice.">
            <span nz-icon nzType="info-circle" nzTheme="outline"></span>
          </span>
        </label>
        <input [(ngModel)]="minimumNoticeHours" name="minimumNoticeHours" [disabled]="viewForm" nz-input type="number"
          placeholder="Enter minimum notice period in hours" class="w-full" />
      </div>
    </div>
    <div class="grid grid-cols-4 gap-2">
      <div class="flex flex-col w-full">
        <label class="form-label"> Select Designation Level : </label>
        <nz-select [(ngModel)]="selectedTherapistLevel" [nzDisabled]="viewForm"
          nzPlaceHolder="Select Designation Level">
          <nz-option *ngFor="let vertical of therapistExpertLevel" [nzValue]="vertical.data"
            [nzLabel]="vertical.data"></nz-option>
        </nz-select>
      </div>
      <div class="w-full">
        <label class="form-label">Rate Therapist :</label>
        <nz-rate [(ngModel)]="rating" [nzDisabled]="viewForm"></nz-rate>
      </div>
      <div>
        <label class="form-label">Max Pricing :</label>
        <input [(ngModel)]="maxPricing" [disabled]="viewForm" nz-input type="number" placeholder="Enter Max Pricing"
          class="w-full" />
      </div>
      <div>
        <label class="form-label">Min Pricing :</label>
        <input [(ngModel)]="minPricing" [disabled]="viewForm" nz-input type="number" placeholder="Enter Min Pricing"
          class="w-full" />
      </div>
    </div>
    <div class="grid grid-cols-3 gap-3">
      <div>
        <label class="form-label">TagLine</label>
        <input [(ngModel)]="tagLine" [disabled]="viewForm" nz-input type="text" placeholder="Enter Tag Line"
          class="w-full" />
      </div>
      <div>
        <label class="form-label required">Languages</label>
        <nz-select [(ngModel)]="selectedLanguage" [nzDisabled]="viewForm" class="w-full"
          nzPlaceHolder="Select Languages" nzMode="multiple">
          <nz-option *ngFor="let expItem of languages" [nzLabel]="expItem.data" [nzValue]="expItem.value"></nz-option>
        </nz-select>
      </div>
      <div>
        <label class="form-label required">
          Slug (We want to enter slug like this example: "test-user") :
        </label>
        <input [(ngModel)]="therapistSlug" [disabled]="viewForm" nz-input type="text" placeholder="Therapist Slug"
          class="w-full" />
      </div>
    </div>
    <div class="grid grid-cols-3 gap-3">
      <div>
        <label class="form-label">Retail Cost</label>
        <input [(ngModel)]="retailCost" [disabled]="viewForm" nz-input type="number" placeholder="Enter Retail Cost"
          class="w-full" />
      </div>
      <div>
        <label class="form-label">Corporate Cost</label>
        <input [(ngModel)]="corporateCost" [disabled]="viewForm" nz-input type="number"
          placeholder="Enter Corporate Cost" class="w-full" />
      </div>
    </div>
    <div class="grid grid-cols-2 gap-2">
      <div>
        <label class="form-label required">About</label>
        <textarea [disabled]="viewForm" [(ngModel)]="about" rows="4" nz-input></textarea>
      </div>
      <div>
        <label class="form-label required">Years Of Experiance</label>
        <input [(ngModel)]="yearOfExperiance" [disabled]="viewForm" nz-input type="number"
          placeholder="Enter Year Of Experiance" class="w-full" />
      </div>
    </div>
    <div class="grid grid-cols-4 gap-4">
      <div>
        <label class="form-label">Map Address(embedded link from google map):</label>
        <input nz-input type="text" placeholder="Enter map address (embedded link from google map)"
          [(ngModel)]="mapAddress" class="w-full" [disabled]="viewForm" />
      </div>
      <div>
        <label class="form-label">offline Map Link</label>
        <input nz-input type="text" placeholder="Enter Offline Map Link" [(ngModel)]="offlineMapLink" class="w-full"
          [disabled]="viewForm" />
      </div>
      <div>
        <label class="form-label">Offline Address</label>
        <input nz-input type="text" placeholder="Enter Offline Address" [(ngModel)]="offlineAddress" class="w-full"
          [disabled]="viewForm" />
      </div>
      <div>
        <label class="form-label">Offline City</label>
        <input nz-input type="text" placeholder="Enter Offline City" [(ngModel)]="offlineCity" class="w-full"
          [disabled]="viewForm" />
      </div>
      <div>
        <label class="form-label required">offline Available</label>
        <nz-switch [(ngModel)]="offlineAvailable" [nzDisabled]="viewForm"></nz-switch>
      </div>
    </div>

    <nz-divider nzText="Bank Info" nzOrientation="left"></nz-divider>
    <div class="grid grid-cols-2 gap-3">
      <div>
        <label class="form-label">Account holder name</label>
        <input [(ngModel)]="bankAccountHolderName" [disabled]="viewForm" nz-input type="text"
          placeholder="Account holder name" class="w-full" />
      </div>
      <div>
        <label class="form-label">Account number</label>
        <input [(ngModel)]="bankAccountNo" [disabled]="viewForm" nz-input type="text" placeholder="Account number"
          class="w-full" />
      </div>
      <div>
        <label class="form-label">IFSC code</label>
        <input [(ngModel)]="bankIfscCode" [disabled]="viewForm" nz-input type="text" placeholder="IFSC code"
          class="w-full" />
      </div>
      <div>
        <label class="form-label">Banking name</label>
        <input [(ngModel)]="bankBankingName" [disabled]="viewForm" nz-input type="text" placeholder="Bank name"
          class="w-full" />
      </div>
    </div>

    <nz-divider nzText="Therapist Pricing Retail" nzOrientation="left"></nz-divider>
    <div class="grid grid-cols-2 gap-3">
      <div>
        <label class="form-label required">Therapist Pricing</label>
        <nz-select [(ngModel)]="selectTherapistPricing" (ngModelChange)="setSelectTherapistPricing($event)"
          class="w-full" nzPlaceHolder="Select Therapist Pricing" [nzDisabled]="viewForm">
          <ng-container *ngFor="let expItem of therapistPricingOption">
            <nz-option *ngIf="expItem.value !== pricingType.SESSION_NUMBER" [nzLabel]="expItem.data"
              [nzValue]="expItem.value"></nz-option>
          </ng-container>
        </nz-select>
      </div>
      <div *ngIf="pricingType.FLAT === selectTherapistPricing">
        <label class="form-label required">Flat Pricing Amount</label>
        <input nz-input type="text" placeholder="Enter flat pricing" [(ngModel)]="flatPricing.amount" class="w-[130%]"
          [disabled]="viewForm" />
      </div>
    </div>
    <!-- sessionMinutesSlabPricing -->
    <div class="grid grid-cols-2 gap-3 pt-2" *ngIf="pricingType.SESSION_MINUTES_SLAB === selectTherapistPricing">
      <div *ngFor="let slab of sessionMinutesSlabPricing.slabs; index as i"
        class="border border-gray-500 rounded-lg p-5">
        <div class="flex flex-row justify-between gap-3">
          <div>
            <label class="form-label">Rate</label>
            <input nz-input type="text" placeholder="Enter rate" [(ngModel)]="slab.rate" class="w-[130%]"
              [disabled]="viewForm" />
          </div>
          <!-- Delete button if not last element -->
          <button *ngIf="i !== sessionMinutesSlabPricing.slabs.length - 1" (click)="deleteSessionMinutesSlab(i)"
            type="button" nz-button nzType="primary" nzShape="circle" [disabled]="viewForm">
            <span nz-icon nzType="minus" nzTheme="outline"></span>
          </button>

          <button *ngIf="i === sessionMinutesSlabPricing.slabs.length - 1" (click)="addSessionMinutesSlab()"
            type="button" nz-button nzType="primary" nzShape="circle" [disabled]="viewForm">
            <span nz-icon nzType="plus" nzTheme="outline"></span>
          </button>
        </div>
        <br />
        <div class="flex flex-col gap-3">
          <div class="flex flex-row flex-1 gap-3">
            <div>
              <label class="form-label">Min Durations(Minutes)</label>
              <input nz-input type="text" placeholder="Enter Min Durations" [(ngModel)]="slab.minDuration"
                class="w-[100%]" [disabled]="viewForm" />
            </div>
            <div>
              <label class="form-label">Max Durations(Minutes)</label>
              <input nz-input type="text" placeholder="Enter Max Durations" [(ngModel)]="slab.maxDuration"
                class="w-[100%]" [disabled]="viewForm" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- sessionNumberPricing removed -->
    <nz-divider nzText="Therapist Pricing Corporate" nzOrientation="left"></nz-divider>
    <div class="grid grid-cols-2 gap-3">
      <div>
        <label class="form-label required">Therapist Pricing</label>
        <nz-select [(ngModel)]="selectTherapistPricingCorporate"
          (ngModelChange)="setSelectTherapistPricingCorporate($event)" class="w-full"
          nzPlaceHolder="Select Therapist Pricing" [nzDisabled]="viewForm">
          <ng-container *ngFor="let expItem of therapistPricingOption">
            <nz-option *ngIf="expItem.value !== pricingType.SESSION_NUMBER" [nzLabel]="expItem.data"
              [nzValue]="expItem.value"></nz-option>
          </ng-container>
        </nz-select>
      </div>
      <div *ngIf="pricingType.FLAT === selectTherapistPricingCorporate">
        <label class="form-label required">Flat Pricing Amount</label>
        <input [disabled]="viewForm" nz-input type="text" placeholder="Enter flat pricing"
          [(ngModel)]="flatPricingCorporate.amount" class="w-[130%]" />
      </div>
    </div>
    <!-- sessionMinutesSlabPricing -->
    <div class="grid grid-cols-2 gap-3 pt-2" *ngIf="
        pricingType.SESSION_MINUTES_SLAB === selectTherapistPricingCorporate
      ">
      <div *ngFor="
          let slab of sessionMinutesSlabPricingCorporate.slabs;
          index as i
        " class="border border-gray-500 rounded-lg p-5">
        <div class="flex flex-row justify-between gap-3">
          <div>
            <label class="form-label">Rate</label>
            <input [disabled]="viewForm" nz-input type="text" placeholder="Enter rate" [(ngModel)]="slab.rate"
              class="w-[130%]" />
          </div>
          <!-- Delete button if not last element -->
          <button *ngIf="i !== sessionMinutesSlabPricingCorporate.slabs.length - 1"
            (click)="deleteSessionMinutesSlabCorporate(i)" type="button" nz-button nzType="primary" nzShape="circle"
            [disabled]="viewForm">
            <span nz-icon nzType="minus" nzTheme="outline"></span>
          </button>

          <button *ngIf="i === sessionMinutesSlabPricingCorporate.slabs.length - 1"
            (click)="addSessionMinutesSlabCorporate()" type="button" nz-button nzType="primary" nzShape="circle"
            [disabled]="viewForm">
            <span nz-icon nzType="plus" nzTheme="outline"></span>
          </button>
        </div>
        <br />
        <div class="flex flex-col gap-3">
          <div class="flex flex-row flex-1 gap-3">
            <div>
              <label class="form-label">Min Durations(Minutes)</label>
              <input nz-input type="text" placeholder="Enter Min Durations" [(ngModel)]="slab.minDuration"
                class="w-[100%]" [disabled]="viewForm" />
            </div>
            <div>
              <label class="form-label">Max Durations(Minutes)</label>
              <input [disabled]="viewForm" nz-input type="text" placeholder="Enter Max Durations"
                [(ngModel)]="slab.maxDuration" class="w-[100%]" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- sessionNumberPricing removed (corporate) -->

    <nz-divider nzText="Vertical and Concern"></nz-divider>
    <div class="grid grid-cols-2 gap-3">
      <div *ngFor="let item of expertiseLevelArray; index as i"
        class="border border-gray-500 rounded-lg p-5 overflow-hidden">
        <div class="flex flex-row justify-between gap-3">
          <nz-select [ngModel]="item.verticalId" [nzDisabled]="viewForm" (ngModelChange)="verticalChange(i, $event)"
            class="flex-1 min-w-0" nzPlaceHolder="Select Vertical">
            <nz-option *ngFor="let vertical of verticalsMasterDataFiltered" [nzValue]="vertical.value"
              [nzLabel]="vertical.label" [nzDisabled]="vertical.disabled"></nz-option>
          </nz-select>
          <!-- Delete button if not last element -->
          <button *ngIf="expertiseLevelArray.length > 1" [disabled]="viewForm" (click)="deleteVertical(i)" type="button"
            nz-button nzType="primary" nzShape="circle">
            <span nz-icon nzType="minus" nzTheme="outline"></span>
          </button>

          <button *ngIf="
              i === expertiseLevelArray.length - 1 &&
              verticalsMasterDataFiltered.length
            " [disabled]="viewForm" (click)="addVertical()" type="button" nz-button nzType="primary" nzShape="circle">
            <span nz-icon nzType="plus" nzTheme="outline"></span>
          </button>
        </div>
        <div class="flex flex-col gap-3 mt-3">
          <div *ngFor="let concern of item.concerns; index as j">
            <div class="flex flex-row flex-1 gap-3">
              <nz-select [ngModel]="concern.concernsId" [nzDisabled]="viewForm"
                (ngModelChange)="concernChange(i, j, $event)" class="flex-1 min-w-0" nzPlaceHolder="Select Concern">
                <nz-option *ngFor="let cItem of item.concernsList" [nzLabel]="cItem.label" [nzValue]="cItem.value"
                  [nzDisabled]="cItem.disabled"></nz-option>
              </nz-select>
              <nz-select [ngModel]="concern.expertLevelId" [nzDisabled]="viewForm"
                (ngModelChange)="expertLevelChange(i, j, $event)" class="flex-1 min-w-0"
                nzPlaceHolder="Select Expertise">
                <nz-option *ngFor="let expItem of expertLevelMasterData" [nzLabel]="expItem.label"
                  [nzValue]="expItem.value"></nz-option>
              </nz-select>
              <button *ngIf="item.concerns.length > 1" [disabled]="viewForm" (click)="deleteConcern(i, j)" type="button"
                nz-button nzType="primary" nzShape="circle">
                <span nz-icon nzType="minus" nzTheme="outline"></span>
              </button>

              <button *ngIf="
                  j === item.concerns.length - 1 && item.concernsList.length
                " [disabled]="viewForm" (click)="addConcern(i)" type="button" nz-button nzType="primary"
                nzShape="circle">
                <span nz-icon nzType="plus" nzTheme="outline"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <nz-divider nzText="Packs Details"></nz-divider>
    <div class="grid grid-cols-3 gap-3">
      <!-- Can Handle Anyo Packs -->
      <div>
        <label class="mt-3 flex items-center space-x-2">
          <input type="checkbox" [(ngModel)]="canHandleAnyoPacks" (change)="onAnyoPackToggle()"
            [disabled]="selectedConcernIds.length === 0 || viewForm" class="w-5 h-5" />
          <span class="text-base">Can handle Anyo packs</span>
        </label>
        <p *ngIf="selectedConcernIds.length === 0" class="text-sm text-red-500 ml-7 mt-1">
          Please select at least one concern to enable this
        </p>
      </div>
    </div>

    <!-- Dynamic Pack Selection -->
    <div class="mt-3 space-y-4">
      <div *ngFor="let pack of therapyPackDetails; let i = index" class="grid grid-cols-3 gap-4 items-start">
        <!-- Pack Selection -->
        <div>
          <label class="form-label required">Pack Details</label>
          <nz-select [(ngModel)]="pack.packId" class="w-full" nzPlaceHolder="Select a pack" nzMode="default"
            [nzDisabled]="!canHandleAnyoPacks || viewForm" (ngModelChange)="onPackSelect(i)">
            <nz-option *ngFor="let expItem of packsDetailsOption" [nzLabel]="expItem.data"
              [nzValue]="expItem.value"></nz-option>
          </nz-select>
        </div>

        <!-- Therapist Type -->
        <div *ngIf="pack.packId">
          <label class="form-label required">Therapist Type</label>

          <div class="flex space-x-4 mt-1">
            <label class="flex items-center space-x-2">
              <input type="radio" name="therapistType{{ i }}" [(ngModel)]="pack.primaryTherapist"
                [disabled]="pack.disabled || false || viewForm" [value]="true" class="w-5 h-5" />
              <span>Primary Therapist</span>
            </label>
            <label class="flex items-center space-x-2">
              <input type="radio" name="therapistType{{ i }}" [(ngModel)]="pack.primaryTherapist" [disabled]="viewForm"
                [value]="false" class="w-5 h-5" />
              <span>Auxiliary Therapist</span>
            </label>
          </div>
          <div *ngIf="pack.disabled" class="mt-1 text-red-600">
            Primary concern for the pack is {{ concernText }}. Please add the
            {{ concernText }} under concerns to assign the therapist as Primary
            therapist.
          </div>
        </div>

        <!-- Pack Expertise -->
        <div *ngIf="pack.primaryTherapist === false">
          <label class="form-label required">Pack Expertise</label>
          <nz-select [(ngModel)]="pack.packExpertise" class="w-full" nzPlaceHolder="Select expertise" nzMode="multiple"
            [disabled]="viewForm">
            <nz-option *ngFor="let expertise of packsExpertise" [nzLabel]="expertise.data"
              [nzValue]="expertise.value"></nz-option>
          </nz-select>
        </div>

        <!-- Remove Button -->
        <div class="col-span-3 flex">
          <button *ngIf="therapyPackDetails.length > 1" (click)="removePack(i)"
            class="bg-red-500 text-white px-3 py-1 rounded" [disabled]="viewForm">
            Remove
          </button>
        </div>
      </div>

      <!-- Add Button -->
      <div class="flex">
        <button (click)="addPack()" class="bg-blue-500 text-white px-3 py-2 rounded"
          [disabled]="!canHandleAnyoPacks || viewForm">
          Add Another Pack
        </button>
      </div>
    </div>
    <nz-divider nzText="Circle Expert info"></nz-divider>
    <div class="grid grid-cols-3 gap-3">
      <div class="w-full">
        <label class="form-label required">Circle Expert</label>
        <nz-switch [(ngModel)]="isExpert" [nzDisabled]="viewForm"></nz-switch>
      </div>
    </div>
    <div class="grid grid-cols-2 gap-3">
      <div class="flex flex-col w-full">
        <label class="form-label"> Select User Interest : </label>
        <nz-select [(ngModel)]="selectedUserInterests" [nzDisabled]="viewForm" nzPlaceHolder="Select User Interests"
          nzMode="multiple">
          <nz-option *ngFor="let item of userInterestTopics" [nzLabel]="item.value" [nzValue]="item.key"></nz-option>
        </nz-select>
      </div>
    </div>
    <nz-divider nzText="Listener info"></nz-divider>
    <div class="grid grid-cols-3 gap-3">
      <div class="w-full">
        <label class="form-label required">Listener</label>
        <nz-switch [(ngModel)]="isListener" [nzDisabled]="viewForm"></nz-switch>
      </div>
    </div>
    <div class="grid grid-cols-2">
      <div>
        <div class="flex">
          <div [ngClass]="
              'flex p-2 items-center border-solid rounded-md upload-pic cursor-pointer mt-1'
            " (click)="show()" id="chooseAvatar">
            <img *ngIf="avatar" class="m-2 cursor-pointer" src="../../../../assets/icons/{{ avatar }}.png" />
            <div class="flex flex-col items-center">
              <p class="text-sm">Choose your avatar</p>
              <div class="flex gap-1"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-avatar mt-[40rem]" id="card" style="display: none">
        <img *ngFor="let avatar of avatarImages" (click)="uploadAvatar(avatar.value, avatar.data)"
          class="m-2 cursor-pointer" src="../../../../assets/icons/{{ avatar.data }}.png" alt="i" />
      </div>
      <div>
        <label class="form-label required">Avatar Name</label>
        <nz-select [(ngModel)]="avatarName" [nzDisabled]="viewForm" class="w-[100%]" nzPlaceHolder="Select AvatarName">
          <nz-option *ngFor="let expItem of avatarNames" [nzLabel]="expItem.data" [nzValue]="expItem.value"></nz-option>
        </nz-select>
      </div>
    </div>
    <nz-divider nzText="Live info"></nz-divider>
    <div class="grid grid-cols-3 gap-3">
      <div class="w-full">
        <label class="form-label required">Live Expert</label>
        <nz-switch [nzDisabled]="viewForm" [(ngModel)]="isGoAnyoLive"></nz-switch>
      </div>
    </div>
    <div class="grid grid-cols-4 gap-4">
      <div class="flex flex-col w-full">
        <label class="form-label"> Add Expert In Anyo Talks : </label>
        <nz-select [(ngModel)]="selectedAnyoTalks" [nzDisabled]="viewForm" nzPlaceHolder="add expert to anyo talks"
          nzMode="multiple">
          <nz-option *ngFor="let talks of anyoTalks" [nzValue]="talks.value" [nzLabel]="talks.data"></nz-option>
        </nz-select>
      </div>
    </div>

    <div nz-row class="pt-4" nzJustify="end">
      <div nz-col>
        <button [disabled]="viewForm" (click)="update()" nz-button nzType="primary">
          Update Experts
        </button>
      </div>
    </div>
  </nz-spin>
</div>
<nz-modal [(nzVisible)]="isVisibleEditEmail" nzTitle="Edit Expert Email" (nzOnCancel)="closeEditEmailPopUp()"
  [nzOkLoading]="isOkLoading" (nzOnOk)="updateExpertEmail()">
  <ng-container *nzModalContent>
    <div class="flex flex-col w-full">
      <label class="form-label">New Email :</label>
      <input [(ngModel)]="newTherapistEmail" nz-input type="text" placeholder="Enter new email" class="w-full" />
    </div>
  </ng-container>
</nz-modal>